import React from 'react';
import { Skeleton, Space } from 'antd';
import classes from './Loader.module.css';

const Loader = () => {
  return (
    <>
      {/* Top Bar Loader */}
      <div className={classes.topBar}>
        <Space>
          <Skeleton.Image active className={`${classes.skeletonImage} ${classes.topbarDocIcon}`} />
          {[...Array(4)].map((_, index) => (
            <div key={index} className={classes.topbarItem}>
              <Skeleton.Button active className={`${classes.skeletonButton} ${classes.topbarButton}`} />
              {/* {index !== 3 && <div className={classes.separator}></div>} */}
            </div>
          ))}
        </Space>

      </div>

      {/* Sidebar Loader */}
      <div className={classes.sidebar}>
        <Space direction="vertical">
          {[...Array(8)].map((_, index) => (
            <Skeleton.Button key={index} active className={classes.skeletonButton} />
          ))}
        </Space>
      </div>

      {/* Full-Screen Loader */}
      <div className={classes.fullScreen}>
        <Skeleton.Button active className={classes.fullScreenSkeleton} />
      </div>

      {/* Bottom Sidebar Loader */}
      <div className={classes.bottomSidebar}>
        {[...Array(2)].map((_, index) => (
          <Skeleton.Button key={index} active className={classes.circleSkeleton} />
        ))}
      </div>
    </>
  );
};

export default Loader;
